class AppState {
    constructor(){
        this._data = {}
    }

    get user()  {  return this._data.user; }
    set user(value  ) { this._data.user = value; }
}

export const state = new AppState();
